import React, { Fragment } from "react";
import { ImageProperty } from "./imageGallery";
import { CopyToClipboard } from "../../../shared/common/CustomCopyToClipboard";
import {
  OutlineXIcon,
  CopyToClipboardIcon,
} from "../../../../assets/icons/index";

interface SlideOverProps extends ImageProperty {
  showSlideOver: (show: boolean) => void;
}

const SlideOver = (props: SlideOverProps) => {
  const handleShowSlideOver = (show: boolean) => {
    props.showSlideOver(show);
  };

  return (
    <Fragment>
      <div className="fixed inset-y-0 right-0 pl-0 sm:pl-10 max-w-full flex">
        <div>
          <div className="h-full flex flex-col bg-white shadow-xl overflow-y-scroll">
            <div className="relative flex-1 py-3 px-4 sm:px-6">
              <div className="flex items-start justify-between mt-3 mb-3">
                <h2
                  className="text-lg font-medium text-gray-900"
                  id="slide-over-title"
                >
                  {props.imageName}
                </h2>
                <div className="ml-3 h-7 flex items-center">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    onClick={() => {
                      handleShowSlideOver(false);
                    }}
                  >
                    <span className="sr-only">Close panel</span>
                    <OutlineXIcon />
                  </button>
                </div>
              </div>

              <div>
                <div className="group block aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden h-52 w-52 m-auto">
                  <img
                    src={props.imageUrl}
                    alt=""
                    className="object-cover pointer-events-none"
                  />
                </div>
                <div>
                  <div className="mb-4 relative">
                    <div className="absolute right-2 mt-2">
                      <button
                        type="button"
                        className="text-gray-700 hover:text-gray-900 hover:shadow"
                        title="Copy to clipboard"
                      >
                        <CopyToClipboard text={props.imageUrl}>
                          <CopyToClipboardIcon />
                        </CopyToClipboard>
                      </button>
                    </div>
                    <div className="text-gray-700 text-xs mt-2 block break-words pr-10 break-all max-w-lg">
                      {props.imageUrl}
                    </div>
                  </div>
                </div>
                <dl className="sm:divide-y sm:divide-gray-200">
                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">
                      QuestionId
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.questionId}
                    </dd>
                  </div>
                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">
                      Question Type
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.questionType}
                    </dd>
                  </div>

                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">
                      Subject
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.subject}
                    </dd>
                  </div>
                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">
                      Domain
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.domain}
                    </dd>
                  </div>
                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">
                      Standard
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.standard}
                    </dd>
                  </div>
                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">
                      USATP ID
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.usatpId}
                    </dd>
                  </div>
                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">Dok</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.dok}
                    </dd>
                  </div>
                  <div className="py-4 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-500">
                      Author
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {props.author}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SlideOver;
